export default __webpack_public_path__ + "e2902c2eaa4a2151a859d42d689b0788.png";